import { marginInfo } from "../../apis/transactional";
import { nonBusinessDays } from "../../redux/actions/funds";
import { BUSINESS_LAYER_RESPONSE, DYANMIC_URL_CONSTANTS, PRODUCT_DETAILS } from "../../utils/global_variables";

async function _getPeriodicities() {
    try {
        const resp = await marginInfo({ type: 'list' });
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: resp.data };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };
    }
}



// Hari K:06-11-2023 :BT-119138:Funds View  - start

const getNumberWithCurrencyFormat = (sNumber) => {
    return Number(sNumber).toLocaleString('en-IN', { minimumFractionDigits: 2 });
};

const _commaFormatter = (value) => {
    try {
        // let x= value;
        // return  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        let num = value.toString(); //make it string .toString() may give issue is already string
        let a = num.split(" ");
        let formattedNum = getNumberWithCurrencyFormat(a[0]) + " " + (a[1] || "");
        return formattedNum.trim();

    } catch (e) {
        return "0.00";
    }

};


const _kFormatter = (value) => {
    try {
        if(!value)
            throw new Error;
        let num = parseFloat(value);
        var si = [
            { value: 1, symbol: "" },
            // { value: 1E3, symbol: "K" },
            // { value: 1E5, symbol: "Lac" },
            { value: 1E7, symbol: "Cr." },
            { value: 1E12, symbol: "Cr." },
            { value: 1E15, symbol: "Cr." },
            { value: 1E18, symbol: "Cr." }
        ];
        var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        var i;
        for (i = si.length - 1; i > 0; i--) {
            if (Math.abs(num) >= si[i].value) {
                break;
            }
        }
        let _returnvalue = (Math.round((num / si[i].value) * 100) / 100).toString().replace(rx, "$1");
        return (_returnvalue + ' ' + si[i].symbol).trim();

    } catch (e) {
        return "0.00";
    }
};

const _filterUniqueObjects = (array, key) => { // hari K:04-12-2023 created function to get unique objects
    const seen = new Set();
    return array.filter(obj => {
        const value = obj[key];
        if (seen.has(value)) {
            return false; // Skip duplicates
        }
        seen.add(value);
        return true;
    });
};

const _getFormatedData = (arrObj) => {
    //Hari K:09-11-2023 arrObj list of funds objects
    const arrIndividualFundsItemsIds = ["Net Available Funds", "Total Utilization", "Total Trading Power Limit", 'Multiplier'];

    const arrIndividualFundsItems = arrObj.filter((each) => arrIndividualFundsItemsIds.includes(each.sDescription));

    const filteredAndTransformedObject = {};
    arrIndividualFundsItems.forEach(item => {
        if (arrIndividualFundsItemsIds.includes(item.sDescription)) {
            const key = item.sDescription.replace(/\s/g, "_");
            filteredAndTransformedObject[key] = { ...item, };
        }
    });

    const arrCategorizedFunds = [];
    arrObj.filter((each) => !arrIndividualFundsItemsIds.includes(each.sDescription))?.forEach((each) => {
        if (each.sIndicator === each.sDescription) {
            arrCategorizedFunds.push({ ...each, data: [] });
        }
    });
    arrObj.forEach((each) => {
        arrCategorizedFunds.forEach((eachObj) => {
            if (each.sIndicator !== each.sDescription && !each.sDescription.includes("T+5")) { // Hari k: 24-07-2024: not showing data points which is inluded  t+5 
                if (each.sIndicator === eachObj.sIndicator) {
                    eachObj.data.push(each);
                }
            }
        });
    });
    return { arrCategorizedFunds: _filterUniqueObjects(arrCategorizedFunds, 'sIndicator'), arrIndividualFundsItems: filteredAndTransformedObject };
};


const _validateUPIId = (upiId) => {
    let regexUPIIDobj = new RegExp(/^[a-zA-Z0-9.\-_]{2,49}@[a-zA-Z._]{2,49}?$/);
    return regexUPIIDobj.test(upiId);
};
// Hari K:06-11-2023 :BT-119138:Funds View -end


const CheckPGDownTime = (strDownTime) => {
    let isValidDownTime = false;
    try {
        if (strDownTime != null && strDownTime !== '') {
            let strarrFromToTime = [];
            strarrFromToTime = strDownTime.split('-');
            if (strarrFromToTime.length > 1) {

                const currentTime = new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
                const tsFromTime = strarrFromToTime[0];
                const tsTOTime = strarrFromToTime[1];
                if (currentTime >= tsFromTime && currentTime <= tsTOTime) {
                    isValidDownTime = true;
                }
            }
            else {
                isValidDownTime = false;
            }
        }
    }
    catch (e) {
        isValidDownTime = false;
    }
    return isValidDownTime;

};

const getAlphDay = (sDay) => {
    try {
        let sRetval = "";
        switch (sDay) {
            case 0:
                sRetval = "SUNDAY";
                break;
            case 1:
                sRetval = "MONDAY";
                break;
            case 2:
                sRetval = "TUESDAY";
                break;
            case 3:
                sRetval = "WEDNESDAY";
                break;
            case 4:
                sRetval = "THURSDAY";
                break;
            case 5:
                sRetval = "FRIDAY";
                break;
            case 6:
                sRetval = "SATURDAY";
                break;
            default: break;
        }
        return sRetval;
    } catch (e) {
        console.log(e);
    }
};



const GetHolidaysStatus = async (dtDateToCheck, dicTrHolidayMaster, dispatch) => {
    let isHoliday = false;
    try {
        if (dicTrHolidayMaster.Count() === 0) {
            await dispatch(nonBusinessDays()).then((response) => {
                if (response.status) {
                    let dsEQSIP = response.result;
                    for (let i = 0; i < dsEQSIP.length; i++) {
                        var d = new Date(dsEQSIP[i].dtNonBusinessDate);
                        if (!dicTrHolidayMaster.ContainsKey(d.getUTCFullYear() + '-' + ('0' + (d.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + d.getUTCDate()).slice(-2))) {
                            dicTrHolidayMaster.Add(d.getUTCFullYear() + '-' + ('0' + (d.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + d.getUTCDate()).slice(-2), dsEQSIP[i].sDateDescription.toString());
                        }
                    }
                }
            });
        }
        let strTodaysDate = dtDateToCheck.getFullYear() + '-' + ('0' + (dtDateToCheck.getMonth() + 1)).slice(-2) + '-' + ('0' + dtDateToCheck.getDate()).slice(-2);
        if (dicTrHolidayMaster != null && dicTrHolidayMaster.Count() > 0) {
            if (dicTrHolidayMaster.ContainsKey(strTodaysDate)) {
                isHoliday = true;
            } else {
                isHoliday = false;
            }
        }

    }
    catch (e) {
        isHoliday = false;
    }
    return isHoliday;
};


// Hari K: 16/07/2021: get holiday list from DB 


const _GetPGDownTime = async (PGDownKeys, dicTrHolidayMaster, type, dispatch) => {
    let isValidTime1 = false;
    let isValidTime2 = false;
    let strPGDowntimeMsg = "";
    let isValidPGDownTime = false;
    let drPGDownTime = {};
    let PG_DOWNTIME_WHEN = "";
    let PG_DOWNTIME_1 = "";
    let PG_DOWNTIME_2 = "";
    let PGDOWNTIMEMESSAGE = "";
    let PGW_DOWNTIME_WHEN = "";
    let PGW_DOWNTIME_1 = "";
    let PGW_DOWNTIME_2 = "";
    let PGWDOWNTIMEMESSAGE = "";
    if (PGDownKeys) {
        let Data = PGDownKeys;
        PG_DOWNTIME_WHEN = Data.PG_DOWNTIME_WHEN || "";
        PG_DOWNTIME_1 = Data.PG_DOWNTIME_1 || "";
        PG_DOWNTIME_2 = Data.PG_DOWNTIME_2 || "";
        PGDOWNTIMEMESSAGE = Data.PG_DOWNTIME_MESSAGE || "";
        if (type === 'FW') {
            PGW_DOWNTIME_WHEN = Data.PGW_DOWNTIME_WHEN || "";
            PGW_DOWNTIME_1 = Data.PGW_DOWNTIME_1 || "";
            PGW_DOWNTIME_2 = Data.PGW_DOWNTIME_2 || "";
            PGWDOWNTIMEMESSAGE = Data.PGW_DOWNTIME_MESSAGE || "";
        }
    }

    try {

        if (PGW_DOWNTIME_WHEN && PGW_DOWNTIME_WHEN !== "USE PG") {
            switch (PGW_DOWNTIME_WHEN) {
                case "ALL DAYS":
                    if (PGW_DOWNTIME_1) {
                        isValidTime1 = CheckPGDownTime(PGW_DOWNTIME_1);
                    }
                    if (PGW_DOWNTIME_2) {
                        isValidTime2 = CheckPGDownTime(PGW_DOWNTIME_2);
                    }
                    break;
                case "ALL WEEKDAYS":
                    let strDayOfWeek = getAlphDay(new Date().getDay());
                    if (strDayOfWeek !== "SUNDAY" && strDayOfWeek !== "SATURDAY") {
                        if (PGW_DOWNTIME_1) {
                            isValidTime1 = CheckPGDownTime(PGW_DOWNTIME_1);
                        }
                        if (PGW_DOWNTIME_2) {
                            isValidTime2 = CheckPGDownTime(PGW_DOWNTIME_2);
                        }
                    }
                    break;
                case "EXCLUDING EQ HOLIDAYS":
                    let holidaystatus = await GetHolidaysStatus(new Date(), dicTrHolidayMaster, dispatch);
                    if (!holidaystatus) {
                        if (PGW_DOWNTIME_1) {
                            isValidTime1 = CheckPGDownTime(PGW_DOWNTIME_1);
                        }
                        if (PGW_DOWNTIME_2) {
                            isValidTime2 = CheckPGDownTime(PGW_DOWNTIME_2);
                        }
                    }
                    break;
                default:
                    break;
            }
            if (isValidTime1 || isValidTime2) {
                isValidPGDownTime = true;
                strPGDowntimeMsg = PGWDOWNTIMEMESSAGE.replace("{0}", PGW_DOWNTIME_1 ? PGW_DOWNTIME_1 : PGW_DOWNTIME_2);
                strPGDowntimeMsg = strPGDowntimeMsg.replace("{1}", PGW_DOWNTIME_2 ? "&" : "");
                strPGDowntimeMsg = strPGDowntimeMsg.replace("{2}", PGW_DOWNTIME_2 ? PGW_DOWNTIME_2 : "");
            }
        }
        else {
            switch (PG_DOWNTIME_WHEN) {
                case "ALL DAYS":
                    if (PG_DOWNTIME_1) {
                        isValidTime1 = CheckPGDownTime(PG_DOWNTIME_1);
                    }
                    if (PG_DOWNTIME_2) {
                        isValidTime2 = CheckPGDownTime(PG_DOWNTIME_2);
                    }
                    break;
                case "ALL WEEKDAYS":
                    let strDayOfWeek = getAlphDay(new Date().getDay());
                    if (strDayOfWeek !== "SUNDAY" && strDayOfWeek !== "SATURDAY") {
                        if (PG_DOWNTIME_1) {
                            isValidTime1 = CheckPGDownTime(PG_DOWNTIME_1);
                        }
                        if (PG_DOWNTIME_2) {
                            isValidTime2 = CheckPGDownTime(PG_DOWNTIME_2);
                        }
                    }
                    break;
                case "EXCLUDING EQ HOLIDAYS":
                    let holidaystatus = await GetHolidaysStatus(new Date(), dicTrHolidayMaster);
                    if (!holidaystatus) {
                        if (PG_DOWNTIME_1) {
                            isValidTime1 = CheckPGDownTime(PG_DOWNTIME_1);
                        }
                        if (PG_DOWNTIME_2) {
                            isValidTime2 = CheckPGDownTime(PG_DOWNTIME_2);
                        }
                    }
                    break;
                default:
                    break;
            }
            if (isValidTime1 || isValidTime2) {
                isValidPGDownTime = true;

                strPGDowntimeMsg = PGDOWNTIMEMESSAGE.replace("{0}", PG_DOWNTIME_1 ? PG_DOWNTIME_1 : PG_DOWNTIME_2);
                strPGDowntimeMsg = strPGDowntimeMsg.replace("{1}", PG_DOWNTIME_2 ? "&" : "");
                strPGDowntimeMsg = strPGDowntimeMsg.replace("{2}", PG_DOWNTIME_2 ? PG_DOWNTIME_2 : "");
            }
        }

        drPGDownTime.IsDownTime = isValidPGDownTime;
        drPGDownTime.PGDowntimeMsg = strPGDowntimeMsg;

    }
    catch (e) {
        drPGDownTime.IsDownTime = false;
        drPGDownTime.PGDowntimeMsg = "Error occured while processing your Request,Kindly Contact the Administrator.";
    }
    return drPGDownTime;
};



const _EncodeToBase64 = (strVal) => {
    var Base64 = { _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", encode: function (e) { var t = ""; var n, r, i, s, o, u, a; var f = 0; e = Base64._utf8_encode(e); while (f < e.length) { n = e.charCodeAt(f++); r = e.charCodeAt(f++); i = e.charCodeAt(f++); s = n >> 2; o = (n & 3) << 4 | r >> 4; u = (r & 15) << 2 | i >> 6; a = i & 63; if (isNaN(r)) { u = a = 64; } else if (isNaN(i)) { a = 64; } t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a); } return t; }, decode: function (e) { var t = ""; var n, r, i; var s, o, u, a; var f = 0; e = e.replace(/[^A-Za-z0-9\+\/\=]/g, ""); while (f < e.length) { s = this._keyStr.indexOf(e.charAt(f++)); o = this._keyStr.indexOf(e.charAt(f++)); u = this._keyStr.indexOf(e.charAt(f++)); a = this._keyStr.indexOf(e.charAt(f++)); n = s << 2 | o >> 4; r = (o & 15) << 4 | u >> 2; i = (u & 3) << 6 | a; t = t + String.fromCharCode(n); if (u != 64) { t = t + String.fromCharCode(r); } if (a != 64) { t = t + String.fromCharCode(i); } } t = Base64._utf8_decode(t); return t; }, _utf8_encode: function (e) { e = e.replace(/\r\n/g, "\n"); var t = ""; for (var n = 0; n < e.length; n++) { var r = e.charCodeAt(n); if (r < 128) { t += String.fromCharCode(r); } else if (r > 127 && r < 2048) { t += String.fromCharCode(r >> 6 | 192); t += String.fromCharCode(r & 63 | 128); } else { t += String.fromCharCode(r >> 12 | 224); t += String.fromCharCode(r >> 6 & 63 | 128); t += String.fromCharCode(r & 63 | 128); } } return t; }, _utf8_decode: function (e) { var t = ""; var n = 0; var r = 0; var c1 = 0; var c2 = 0; var c3 = 0; while (n < e.length) { r = e.charCodeAt(n); if (r < 128) { t += String.fromCharCode(r); n++; } else if (r > 191 && r < 224) { c2 = e.charCodeAt(n + 1); t += String.fromCharCode((r & 31) << 6 | c2 & 63); n += 2; } else { c2 = e.charCodeAt(n + 1); c3 = e.charCodeAt(n + 2); t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63); n += 3; } } return t; } };
    return Base64.encode(strVal);
};

// Hari k:14-03-2024
const _createDynamicUrl = (url, objLoginSession) => {
    let dynamicUrl = url;
    if (dynamicUrl !== '' && dynamicUrl !== undefined && dynamicUrl !== null) {
        if (dynamicUrl.indexOf(DYANMIC_URL_CONSTANTS.UID) > -1) {
            dynamicUrl = dynamicUrl.replace(DYANMIC_URL_CONSTANTS.UID, objLoginSession?.data?.user_id);
        }
        if (dynamicUrl.indexOf(DYANMIC_URL_CONSTANTS.GROUPID) > -1) {
            dynamicUrl = dynamicUrl.replace(DYANMIC_URL_CONSTANTS.GROUPID, objLoginSession?.data?.others?.groupId);
        }
        if (dynamicUrl.indexOf(DYANMIC_URL_CONSTANTS.THEME) > -1) {
            dynamicUrl = dynamicUrl.replace(DYANMIC_URL_CONSTANTS.THEME, PRODUCT_DETAILS.DEFAULT_THEME.trim().toUpperCase() === "DARK" ? "D" : "L");
        }
        if (dynamicUrl.indexOf(DYANMIC_URL_CONSTANTS.URI_OCTOKEN) > -1) {
            dynamicUrl = dynamicUrl.replace(DYANMIC_URL_CONSTANTS.URI_OCTOKEN, encodeURIComponent(objLoginSession?.data?.others?.ocToken));
        }
        if (dynamicUrl.indexOf(DYANMIC_URL_CONSTANTS.NEFT_PRODUCTNAME) > -1) {
            dynamicUrl = dynamicUrl.replace(DYANMIC_URL_CONSTANTS.NEFT_PRODUCTNAME, PRODUCT_DETAILS.PLEDGE_PRODUCT);
        }
    }
    return dynamicUrl;
};

export {
    _getPeriodicities, _getFormatedData, _commaFormatter, _kFormatter, _validateUPIId, _GetPGDownTime, _createDynamicUrl, _EncodeToBase64
};